/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Uno_Welcome_MessageInputs */



/**
* | output |
* | --- |
* | "Here I am, {name}. This is my spot from now on - ask me anything about oneAI, any time. Where would you like to start?" |
*
* @param {Uno_Welcome_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_message = /** @type {((inputs: Uno_Welcome_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Da bin ich, ${i?.name}. Hier findest du mich ab jetzt - frag mich jederzeit alles zu oneAI. Womit möchtest du anfangen?`)
	return /** @type {LocalizedString} */ (`Here I am, ${i?.name}. This is my spot from now on - ask me anything about oneAI, any time. Where would you like to start?`)
});